import { Navigate, useParams } from 'react-router-dom';
import { REALTOR_AUTO_APP_BASE_URL } from '../../../config/ieumConfig';
import { realtorAutoAdminFetch } from '../../../services/realtorAutoAdminService';
import { RealtorAutoAdminApp } from './RealtorAutoAdminApp';

const SECTIONS = new Set([
  'dashboard',
  'template',
  'irospdf',
  'payment-macro',
  'crawler',
  'worker-queue',
  'failure-log',
  'payments',
]);

const RealtorAutoAdminPage = () => {
  const { section = 'dashboard' } = useParams();
  if (!SECTIONS.has(section)) {
    return <Navigate to="/admin/realtorauto/dashboard" replace />;
  }
  return (
    <RealtorAutoAdminApp
      key={section}
      section={section}
      embedded
      request={realtorAutoAdminFetch}
      adminBasePath="/admin/realtorauto"
      appBasePath={REALTOR_AUTO_APP_BASE_URL}
      apiBasePath="/api/realtorauto-admin"
    />
  );
};

export default RealtorAutoAdminPage;
